<template>
  <v-app>
    <nav>
      <v-toolbar dark class="primary">
        <v-toolbar-title>
          <span>BaBuM</span><span class="font-weight-light">BarcodeScanner</span>
        </v-toolbar-title>
      </v-toolbar>
    </nav>

    <v-content>
      <SimpleTest/>
    </v-content>

  </v-app>
</template>

<script>
import SimpleTest from './components/SimpleTest';

export default {
  name: 'App',

  components: {
    SimpleTest,
  },

  data: () => ({
    //
  }),
};
</script>
